import { CompleteStore } from '../../../../../reducers/reducerTypes';
import { DateRangeType } from '../../storeTypes';

export const getDateRange = (state: CompleteStore): DateRangeType => {
	return state.filters.dateTime;
};
